// extracted by mini-css-extract-plugin
export default {"root":"SectionTitle_root__463ad","sectionTitle":"SectionTitle_sectionTitle__ufSDF","block":"SectionTitle_block__XX9CL"};